/**
 * Utility to convert Autodesk API URLs to proxy paths in development
 * This avoids CORS issues by routing requests through the Vite dev server
 */
export function getProxiedUrl(url: string): string {
    // Only proxy in development (when running on localhost)
    if (typeof window !== "undefined" && window.location.hostname === "localhost") {
        const autodeskApiUrl = "https://developer-dev.api.autodesk.com";
        const cdnUrl = "https://cdn-us-dev.schema.autodesk.com";

        // Check if URL is an Autodesk API URL
        if (url.startsWith(autodeskApiUrl)) {
            return url.replace(autodeskApiUrl, "/api");
        } else if (url.startsWith(cdnUrl)) {
            return url.replace(cdnUrl, "/api/cdn");
        }
    }

    // Return original URL in production or if not an Autodesk API URL
    return url;
}
